import { randomBytes } from 'crypto-browserify';

export const getImageFileName = () => {
  return randomBytes(32).toString('hex');
};

export const dataURItoBlob = (dataURI) => {
  let byteString;
  let mimeString;
  let ia;

  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = encodeURI(dataURI.split(',')[1]);
  }
  // separate out the mime component
  mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
};

export const isImei = (imeiString) => {
  let i = 0;
  let vl_Sum1 = 0,
    vl_Sum2 = 0,
    vl_Total = 0;
  let vl_Temp = 0;

  for (i = 0; i < 14; i++) {
    /*(1)將奇數位數字相加(從1開始計數)*/
    if (i % 2 === 0) {
      vl_Sum1 = vl_Sum1 + parseInt(imeiString[i]);
    } else {
      /*(2)將偶數位數字分別乘以2,分別計算個位數和十位數之和(從1開始計數)*/
      vl_Temp = parseInt(imeiString[i]) * 2;
      if (vl_Temp < 10) {
        vl_Sum2 = vl_Sum2 + vl_Temp;
      } else {
        vl_Sum2 = vl_Sum2 + 1 + vl_Temp - 10;
      }
    }
  }
  /*(1)+(2)*/
  vl_Total = vl_Sum1 + vl_Sum2;
  /*如果得出的數個位是0則校驗位爲0,否則爲10減去個位數 */
  if (vl_Total % 10 === 0) {
    if (imeiString[14] === '0') {
      return true;
    }
  } else {
    if ((10 - (vl_Total % 10)).toString() === imeiString[14]) {
      return true;
    }
  }
  return false;
};
